@if (!subMenuItem) {
    <div [@slideInOutLeft] data-testid="header-hamburger-menu-content">
        @for (navigationItem of getNavigationItems(); track navigationItem; let last = $last) {
            <ap-vertical-navigation-item
                [navigationItem]="navigationItem"
                [isLastItem]="last"
                (navigationClicked)="navigate($event)"
            ></ap-vertical-navigation-item>
        }
        @if (isLoggedIn() !== null) {
            <div class="vertical-navigation-item--login">
                <a
                    tabindex="0"
                    (keydown.enter)="loginLogout.emit(isLoggedIn())"
                    (keydown.space)="loginLogout.emit(isLoggedIn())"
                    (click)="loginLogout.emit(isLoggedIn())"
                >
                    @if (isLoggedIn()) {
                        {{ 'header.logout' | apContent }}
                    } @else {
                        {{ 'header.login' | apContent }}
                    }
                </a>
            </div>
        }
    </div>
}

@if (subMenuItem) {
    <ap-vertical-submenu
        [@slideInOutRight]
        (@slideInOutRight.start)="disableOverflowX()"
        (@slideInOutRight.done)="enableOverflowX()"
        [navigationItem]="subMenuItem"
        (navigationClicked)="navigate($event)"
        (backClicked)="toggleSubMenuItem()"
        data-testid="vertical-submenu"
    >
    </ap-vertical-submenu>
}
